var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audiopreview-wrapper",style:(`background:url(${_vm.backgroundUrlPath})`)},[_c('audio',{staticClass:"audiopreview-video-element",attrs:{"controls":"","autoplay":"","name":"media"}},[_c('source',{attrs:{"src":_vm.fileUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }